import { render, staticRenderFns } from "./SupportCenterSidebar.vue?vue&type=template&id=5279522d"
import script from "./SupportCenterSidebar.vue?vue&type=script&lang=js"
export * from "./SupportCenterSidebar.vue?vue&type=script&lang=js"
import style0 from "./SupportCenterSidebar.vue?vue&type=style&index=0&id=5279522d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports